/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MembershipTypes {
    "use strict";
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MembershipType> {
        public disableCrud: boolean = false;
        private _taxItemsList: Array<Model.TaxItem> = [];

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template, params.isPrimarySection, params.handlesOwnCrud,
                params.baseEndpoint, params.sectionEndpoint,
                params.loggingService, params.dataService, params.identityService, params.noun, null,params.sectionSecurityKey);
        }

        createSectionModelInstance(postAdd: (data: any)=>any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = <Model.MembershipType>data;
                this.model.ownedByLocationName = "global";
                this.getTaxInfo(this.model);
            });
        }

        /**
         * Load information about tax info to populate data for tax override dropdown
         * @param {Object} data - membership model
         * */
        getTaxInfo(data: Model.MembershipType): void {
            this.dataService.customMethodData("api/Tax", "GET", {})
                .then((response) => {
                    let acceptableTaxType = [];
                    response.data.taxItems.forEach((item: Model.TaxItem) => {
                        if (item.taxItemType === Model.TaxItemTypeEnum.Membership && item.isActive === true) {
                            acceptableTaxType.push(item);
                        }
                    });
                    this.taxItems = this.setTaxTypesName(response.data.taxTypes,acceptableTaxType);
                })
        }

        get taxItems() {
            return this._taxItemsList
        }

        set taxItems(data: Array<Model.TaxItem>) {
            this._taxItemsList = data;
        }

        /**
         * Listen tax override changes and clear tax options
         * @param {boolean} model - is taxable
         * */
        public clearTaxOptions(model: boolean): void {
            if (model === false) {
                this.model.taxItem_LId = '';
                this.model.isTaxOnEnrollment = false;
                this.model.isTaxOnRenewal = false;
                this.model.isTaxRecurring = false;
            }
        }

        /**
         * Validate tax fees. At least one to be selected
         * */
        public validateTaxFee(): boolean {
            return !(this.model.isTaxOnEnrollment || this.model.isTaxOnRenewal || this.model.isTaxRecurring);
        }

        /**
         * Transform state enum into boolean property
         * @param {Object} data - membership model
         * */
        static parseState(data: Model.MembershipType): void {
            data.isActive = data.objectState === Model.ObjectStateEnum.Active;
        }

        createSectionModelCopy(): Model.MembershipType {
            let item = <Model.MembershipType>(this.model);
            item.id = null;
            return item;
        }


        activate(): void {
            // Initialize model properties
            this.getTaxInfo(this.model);
            MainSection.parseState(this.model);
            super.activate();
        }

        private setTaxTypesName(taxTypes, acceptableTaxTypes): Array<any>{
            let taxTypesNames = {};
            taxTypes.forEach((item)=>{taxTypesNames[item.id]=item.displayName});
            acceptableTaxTypes.map((type)=>{
                return type.taxItemRates.forEach((item) => {
                    item.displayName = taxTypesNames[item.taxType_LId];
                });
            });
            return acceptableTaxTypes;
        }

        public getCurrentTaxItem():any{
            let foundTax = _.find(this.taxItems,(item)=>{
                return item.id === this.model.taxItem_LId;
            });
            return foundTax && foundTax.taxItemRates;
        }
    }
}